import React from 'react';
import QuestionnaireHeaderBar from "../containers/QuestionnaireHeaderBar";
import ResponseHeader from "../containers/ResponseHeader";
import {connect} from 'react-redux';
import { withRouter } from "react-router";

class Questionnaire extends React.Component {
  render() {
    let props = this.props;
    return (
      <div>
        <div style={{paddingTop: 80}}>
          <QuestionnaireHeaderBar inAnswers={/answers/.test(props.location.pathname)} inOptions={/options/.test(props.location.pathname)} inResults={/results/.test(props.location.pathname)} inHarvestStrategy={/harvestStrategy/.test(props.location.pathname)} params={props.params} />
          <div style={{padding: '0px 20px 20px 20px'}}>
          <ResponseHeader inResults={/results/.test(props.location.pathname)} inAnswers={/answers/.test(props.location.pathname)} inHarvestStrategy={/harvestStrategy/.test(props.location.pathname)} params={props.params} />
          {props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  null
)(withRouter(Questionnaire));
